import { toast } from 'react-toastify';
import type { runHeliosHegFunctionRes } from 'types/helios/runFunctions';

/**
 * Shows an error toast when a Helios function returns a failed result.
 * @returns true if the result was an error (caller should stop success handling)
 */
export const showHeliosFunctionResultError = (resultData: runHeliosHegFunctionRes | undefined, t: (key: string) => string): boolean => {
  if (resultData?.resultState === 'Error') {
    toast.error(resultData.message || t('common.error'));
    return true;
  }

  return false;
};
